function stopSwatchEvent(event, immediate) {
  if (!event) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (immediate && event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }
}

// Agencia SEO 25/06/2025
function getSwatchImageElement(element) {
  const targetImageId = element.getAttribute("data-target-image-id");
  if (targetImageId) {
    return document.getElementById(targetImageId);
  }

  return document.getElementById(element.id.replace("variant", "imagen"));
}

function getSwatchVariantImage(element) {
  const variantImage = element.getAttribute("data-variant-image") || element.getAttribute("imagenes-id") || "";
  return variantImage && variantImage !== "null" ? variantImage : "";
}

// Mouse over
function overmouseimage(element, event) {
  stopSwatchEvent(event);

  if (element.id == "") {return;}
  const imageElement = getSwatchImageElement(element);
  const variantImage = getSwatchVariantImage(element);
  if (imageElement && variantImage) {
    imageElement.srcset = variantImage;
    imageElement.src = variantImage;
  }

  const productCard = element.closest('.grid-product');
  const secondaryImage = productCard ? productCard.querySelector('.grid-product__secondary-image img') : null;
  if (secondaryImage && variantImage) {
    if (!secondaryImage.getAttribute('data-default-srcset')) {
      secondaryImage.setAttribute('data-default-srcset', secondaryImage.getAttribute('srcset') || '');
    }
    if (!secondaryImage.getAttribute('data-default-src')) {
      secondaryImage.setAttribute('data-default-src', secondaryImage.getAttribute('src') || '');
    }
    secondaryImage.srcset = variantImage;
    secondaryImage.src = variantImage;
  }
}

// Mouse out
function outmouseimage(element, event) {
  stopSwatchEvent(event);
  const imageElement = getSwatchImageElement(element);
  const defaultSrcset = imageElement ? imageElement.getAttribute("data-srcset") : null;
  const defaultSrc = imageElement ? imageElement.getAttribute("data-default-src") : null;
  if (imageElement && defaultSrcset && defaultSrcset !== "null") {
    imageElement.srcset = defaultSrcset;
    imageElement.src = defaultSrcset;
    return;
  }
  if (imageElement && defaultSrc) {
    imageElement.removeAttribute("srcset");
    imageElement.src = defaultSrc;
    return;
  }
  if (imageElement) {
    imageElement.removeAttribute("srcset");
  }

  const productCard = element.closest('.grid-product');
  const secondaryImage = productCard ? productCard.querySelector('.grid-product__secondary-image img') : null;
  if (secondaryImage) {
    const defaultSrcset = secondaryImage.getAttribute('data-default-srcset');
    const defaultSrc = secondaryImage.getAttribute('data-default-src');
    if (defaultSrcset && defaultSrcset !== 'null') {
      secondaryImage.srcset = defaultSrcset;
    }
    if (defaultSrc && defaultSrc !== 'null') {
      secondaryImage.src = defaultSrc;
    }
  }
  if (typeof $ !== "undefined") {
    $('.load1').removeAttr('srcset');
  }
}

// Click handler
function dobleclick(element, url, divname, variant, event) {
  stopSwatchEvent(event, true);

  // Remove 'active' class from all swatches in the same product div
  const swatchContainerId = element.getAttribute("data-swatch-container-id") || `divcolor-${divname}`;
  const swatchContainer = document.getElementById(swatchContainerId);
  if (swatchContainer) {
    const swatches = swatchContainer.querySelectorAll('.color-swatch');
    swatches.forEach(swatch => swatch.classList.remove('active'));
  }

  // Add 'active' class to the clicked swatch
  const selectedSwatch = document.getElementsByName(`variant-${variant}`)[0];
  if (selectedSwatch) {
    selectedSwatch.classList.add('active');
  }

  // Update the main image link and data-srcset
  const mainImageLinkId = element.getAttribute("data-main-link-id") || `imagMain${element.id}`;
  const mainImageLink = document.getElementById(mainImageLinkId);
  const imageElement = getSwatchImageElement(element);
  const variantImage = getSwatchVariantImage(element);
  if (mainImageLink) {
    mainImageLink.href = url;
  }
  if (imageElement) {
    imageElement.setAttribute("data-srcset", variantImage);
    if (variantImage) {
      imageElement.srcset = variantImage;
      imageElement.src = variantImage;
    }
  }
  if (event && window.matchMedia("(min-width: 768px)").matches) {
    window.location.href = element.getAttribute('data-product-url') || url;
    return;
  }

  // Mobile double-tap logic
  if (window.matchMedia("(max-width: 767px)").matches) {
    const currentTime = new Date().getTime();
    if (!element.touchtime) {
      element.touchtime = currentTime;
    } else if (currentTime - element.touchtime < 800) {
      element.touchtime = 0;
      window.location.href = url;
    } else {
      element.touchtime = currentTime;
    }
  }
}

// Mouse enter
function mouseenter(element, event) {
  stopSwatchEvent(event);
  const divSelector = document.getElementById(element.id.replace("variant", "div"));
  if (divSelector) {
    divSelector.remove();
  }
}
